/**
 * @desc 保存
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(body: defs.fulfilment.InPlanMasterRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/inPlanMaster/save`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
